import { render, staticRenderFns } from "./internationalTestOrder.vue?vue&type=template&id=5b8d0c63&scoped=true&"
import script from "./internationalTestOrder.vue?vue&type=script&lang=js&"
export * from "./internationalTestOrder.vue?vue&type=script&lang=js&"
import style0 from "./internationalTestOrder.vue?vue&type=style&index=0&id=5b8d0c63&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b8d0c63",
  null
  
)

export default component.exports